import React from 'react';
import { Card, CardContent, Flex, Text } from '@stepstone-genesis/components';
import { ClockIcon } from '@stepstone-genesis/icons';
// Splits "text with **bold** parts" into alternating normal/bold spans.
const InlineBoldText = ({ text }) => {
    const parts = text.split(/\*\*(.+?)\*\*/);
    return (React.createElement(React.Fragment, null, parts.map((part, i) => i % 2 === 1 ? (React.createElement(Text, { key: i, as: "strong", size: "small", fontWeight: "fontWeightBold", sx: { display: 'inline' } }, part)) : (React.createElement(React.Fragment, { key: i }, part)))));
};
const LimitError = ({ content }) => (React.createElement(Card, { variant: "compact", sx: {
        width: '100%',
        borderRadius: 'radiusL4',
        boxShadow: 'boxShadowNone',
        backgroundColor: 'colorBackgroundSecondaryDefault',
        borderStyle: 'none',
    } },
    React.createElement(CardContent, { sx: { padding: 'spaceM' } },
        React.createElement(Flex, { flxDirection: "column", gap: "spaceS" },
            React.createElement(ClockIcon, { size: "small", color: "colorTextInfoStrongDefault" }),
            React.createElement(Text, { size: "small", color: "colorTextPrimaryDefault" },
                React.createElement(InlineBoldText, { text: content }))))));
export default LimitError;
